<template>
<div>
<!-- <v-overlay v-if="alert && !this.cookieConsent" v-model="overlay"> -->
<div class="alert-main" v-if="alert && !this.cookieConsent">
        
    <img src="../assets/cookie.svg">
      <div class="text">Ta stran uporablja piškotke za izboljšanje uporabniške izkušnje in za spremljanje podatkov o obiskanosti strani.</div>
			<v-btn @click="dismissAlert">Sprejemam piškotke</v-btn>
      
    </div>

    <div class="text-center">
    </div>
    <!-- </v-overlay> -->
  </div>
</template>

<style lang="scss" scoped>

@import 'variables.scss';

    .alert-main {
			position: fixed;
			min-width: 400px;
			width: 100vw;
			background-color: white;
			bottom: 0;
			display:flex;
			align-items: center;
			padding: 0 1em;
		box-sizing: border-box;
		justify-content: center;
		box-shadow: 0 0 61px #13131338;
		z-index:3;

		@include screen('mobile') {
				flex-direction:column;
				padding:1em;
      }

	
		
			img {
				width: 50px;
				margin: 1em 0;
			}
		}

		button {
			background-color:#e0251b;
			color:white;
	
		}

		.text {
			margin-bottom:1em;
			line-height:1.6;
			text-align:left;
			margin:0 1em;
			@include screen('mobile') {
				text-align:center;
				margin-bottom:1em;
      }
		}

		.v-overlay__content {
			width:100%!important;
			height:100%!important;
		}
</style>

<script>
export default {
    data() {
        return {
				warning: 'warning',
				notice: 'notice',
				danger: 'danger',
				alert: true,
				overlay: true,
				cookieConsent: null
        };
    },
    methods: {
      dismissAlert() {
        this.$cookies.set("CookieConsent", 1, "30d")
        this.cookieConsent = 1;
      },
    },
	mounted() {
    this.cookieConsent = this.$cookies.get("CookieConsent")
	},
};
</script>